/**
 * Regex pattern matching agent-internal PR metadata tags that should not be displayed to users.
 *
 * These tags are part of the structured output format used by the agent runtime:
 * - `<pr_title>` / `<pr_description>`: structured PR metadata produced by the LLM
 * - `<response_structure>`: prompt envelope that models sometimes echo back
 * - `<empty>`: sentinel token meaning "no PR update needed"
 */
const PR_METADATA_TAG_PATTERN = /<pr_title>|<pr_description>|<response_structure>|<empty>/i

/**
 * Returns true if the content contains agent-internal PR metadata tags
 * that should be excluded from user-facing displays.
 */
export function hasPrMetadataTags(content: string): boolean {
  return PR_METADATA_TAG_PATTERN.test(content)
}

/**
 * Strips agent-internal PR metadata tags and their contents from a string.
 * Returns the remaining text (trimmed), which may be empty if the entire
 * content was metadata.
 */
export function stripPrMetadataTags(content: string): string {
  return content
    .replace(/<pr_title>.*?<\/pr_title>|<pr_description>.*?<\/pr_description>|<empty>/gs, '')
    .replace(/<response_structure>.*?<\/response_structure>/gs, '')
    .trim()
}
